/* Base translations · GL, head-wise GL, head timeline, sub-ledger / trade-payable tabs — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): headwiseGL, headTimeline, glEntry, subLedgerTab, tradePayableTab. */
export const I18N_BASE_GL_HEADS = {
  en: {
    headwiseGL: {
      title: "Upload Head-wise GL",
      descPre: "Upload a GL detail for one or more FS heads. Reuses the standard GL parser. Choose ",
      descAppendBold: "Append",
      descMid: " to add rows without touching existing data, or ",
      descReplaceBold: "Replace",
      descPost: ' to swap out prior entries for the same heads (a snapshot is kept so the Re-sample "Review affected items" flow can trace which sampled items were touched).',
      mode: "Mode",
      append: "Append",
      appendBody: "Adds these rows on top of any existing GL. Nothing is deleted.",
      replacePerHead: "Replace (per head)",
      replaceBody: 'Removes existing GL rows for accounts under the selected FS heads, then inserts these rows. A snapshot is saved for the Re-sample "Review affected items" flow.',
      fsHeads: "FS heads",
      searchPh: "Search code / line / placement",
      groupByPlacement: "Group by placement",
      noLinesMatch: 'No FS lines match "{q}"',
      selectedLine: "Selected: {codes}",
      selectedPlusPlacements: " + {placements}",
      glFile: "GL file",
      loadedRows: "Loaded {n} rows",
      clickToReplace: "(click to replace)",
      parsingBg: "Parsing large file in background…",
      parsing: "Parsing…",
      choose: "Choose file — .csv, .xlsx, .xls, .xlsm",
      columnMapping: "Column mapping",
      voucherCol: "Voucher column:",
      noVoucherMapped: "No voucher column mapped — rows will get V-#### placeholders",
      notMapped: "— Not mapped —",
      cancel: "Cancel",
      uploading: "Uploading…",
      uploadAppend: "Upload (append)",
      uploadReplace: "Upload (replace per head)",
      toastUnsupported: "Unsupported file — use CSV or Excel",
      toastFinalizeNoJob: "Upload finalize returned no job id",
      toastFileFirst: "Upload a file first",
      toastPickFsHead: "Pick at least one FS head or placement",
      toastPreviewFailed: "Preview failed",
      toastFileParseFailed: "File parse failed",
      toastCompleteAppend: "Head-wise upload complete — {n} inserted",
      toastCompleteReplace: "Head-wise upload complete — {n} inserted · {r} earlier head-wise rows for the selected heads replaced in the head-wise store (0 = first head-wise upload for these heads; main GL rows are never touched)",
      toastCompleteFailed: "Head-wise upload failed",
      parsingFile: "Parsing file…",
      uploadingChunks: "Uploading {mb} MB in chunks…",
      fields: {
        voucherLabel: "Voucher / UIN",
        voucherHint: "Column that carries the voucher number or UIN — leave blank to fall back to V-#### placeholders",
        entryDate: "Entry Date",
        accountCode: "Account Code",
        accountName: "Account Name",
        description: "Description",
        debit: "Debit",
        credit: "Credit",
        vendorCustomer: "Vendor / Customer",
      },
    },
    headTimeline: {
      title: "Head-wise timeline",
      desc: "Every upload that touched this FS head, newest first. Replace uploads can be undone (restores the snapshot rows) if no newer Replace has already superseded them on this head.",
      loading: "Loading timeline…",
      noUploads: "No head-wise uploads on {code} yet.",
      when: "When",
      by: "By",
      mode: "Mode",
      inserted: "Ins.",
      replaced: "Repl.",
      status: "Status",
      actions: "Actions",
      undone: "Undone",
      undoneBy: "Undone by {name} — {at}",
      live: "live",
      diff: "Diff",
      undo: "Undo",
      undoConfirm: "Undo this Replace? The snapshot rows will be re-inserted as head-wise, and everything this upload added will be removed.",
      undoComplete: "Undo complete — {deleted} removed · {restored} restored",
      undoFailed: "Undo failed",
      diffFailed: "Failed to load diff",
      diffTitle: "Diff preview — snapshot vs current",
      diffDesc: "Left column: rows captured immediately before the Replace ran. Right column: rows currently in this head-wise pool.",
      loadingDiff: "Loading diff…",
      snapshotHdr: "Snapshot (before) · {n} rows",
      currentHdr: "Current (after) · {n} rows",
      voucher: "Voucher",
      acc: "Acc",
      andMore: "…and {n} more.",
    },
    glEntry: {
      loading: "Loading entry…",
      notFound: "Entry not found",
      back: "Back to GL Import",
      title: "GL Entry",
      copy: "Copy",
      copied: "Copied",
      copyFailed: "Copy failed",
      labels: {
        entryId: "Entry ID",
        voucher: "Voucher / UIN",
        entryDate: "Entry date",
        accountCode: "Account code",
        accountName: "Account name",
        debit: "Debit",
        credit: "Credit",
        net: "Net (Dr − Cr)",
        description: "Description",
        vendorCustomer: "Vendor / customer",
        categoryHint: "Category hint",
        postedBy: "Posted by",
        postedTime: "Posted time",
        period: "Period",
      },
    },
    subLedgerTab: {
      dsoNoOpeningAr: "n/a — opening AR not in the sub-ledger",   // Batch 25 · C6
      title: "Sub GL Analyzer — Sales/Receivable",
      uploadBtn: "Upload Sub-Ledger Detail",
      empty: "No analytics cached yet — upload a sub-ledger and hit Recompute.",
      dsoLabel: "DSO (Days Sales Outstanding) — trailing 90 days",
      cnLabel: "Credit-note ratio — monthly",
      ptdLabel: "Payment-term deviation — monthly",
      ptdLabelFull: "Payment-term deviation rate — monthly",
      woLabel: "Write-off rate — monthly",
      cPeriodEnd: "Period end",
      cArAvg: "AR (trailing avg)",
      cRevenue90d: "Revenue (90d)",
      cDsoDays: "DSO (days)",
      cInvoices: "Invoices",
      cCreditNotes: "Credit notes",
      cRatio: "Ratio",
      cEligible: "Eligible",
      cDeviated: "Deviated",
      cWriteOffs: "Write-offs",
      cRate: "Rate",
      cPeriod: "Period",
      dcCustomer: "Customer",
      dcRefInvoice: "Ref invoice",
      dcAmount: "Amount",
      coverageLabel: "Reference-Invoice-ID coverage: {pct}",
      coverageOf: "({elig} eligible of {total} invoices)",
      coverageBadge: "threshold: > {n} days late",
      coverageLow: "Coverage under 20% — this rate is non-representative until more invoice-linkage is provided.",
      drillNote: " A rising trend + this peek is enough for enquiry; a full list is a Sampling-tab job.",
      tRecomputeQueued: "O2C recompute queued on the worker fleet.",
      tRecomputed: "O2C analytics recomputed.",
    },
    tradePayableTab: {
      title: "Sub GL Analyzer — Trade Payable",
      uploadBtn: "Upload Trade Payable Detail",
      empty: "No analytics cached yet — upload a trade-payable file and hit Recompute.",
      dpoLabel: "DPO (Days Payable Outstanding) — trailing 90 days",
      prLabel: "Purchase-return ratio — monthly",
      ppdLabel: "Early-Payment Discount Capture — monthly",
      cPeriodEnd: "Period end",
      cApAvg: "AP (trailing avg)",
      cPurchases90d: "Purchases (90d)",
      cDpoDays: "DPO (days)",
      cBills: "Bills",
      cDebitNotes: "Debit notes",
      cRatio: "Ratio",
      cEligible: "Eligible",
      cTaken: "Taken",
      cTakeupRate: "Take-up rate",
      cPeriod: "Period",
      dcVendor: "Vendor",
      dcRefBill: "Ref bill",
      dcAmount: "Amount",
      coverageLabel: "Reference-Bill-ID + Discount-Days coverage: {pct}",
      coverageOf: "({elig} eligible of {total} bills)",
      coverageBadge: "only bills with a discount window & a linked payment",
      coverageLow: "Coverage under 20% — this capture rate is non-representative until more discount-window + payment linkage is provided.",
      tRecomputeQueued: "A/P recompute queued on the worker fleet.",
      tRecomputed: "Trade-Payable analytics recomputed.",
    },
  },
  ar: {
    headwiseGL: {
      title: "تحميل الأستاذ العام حسب الرأس",
      descPre: "قم بتحميل تفاصيل الأستاذ العام لرأس أو أكثر من رؤوس القوائم المالية. يستخدم نفس محلل الأستاذ العام القياسي. اختر ",
      descAppendBold: "إلحاق",
      descMid: " لإضافة صفوف دون المساس بالبيانات الحالية، أو ",
      descReplaceBold: "استبدال",
      descPost: ' لتبديل الإدخالات السابقة لنفس الرؤوس (يتم الاحتفاظ بلقطة كي يتتبع تدفق "مراجعة العناصر المتأثرة" أي عناصر مُعاينة تأثرت).',
      mode: "الوضع",
      append: "إلحاق",
      appendBody: "يُضيف هذه الصفوف فوق أي أستاذ عام قائم. لا يُحذف شيء.",
      replacePerHead: "استبدال (لكل رأس)",
      replaceBody: 'يُزيل صفوف الأستاذ العام الحالية للحسابات تحت رؤوس القوائم المالية المحددة، ثم يُدرج هذه الصفوف. تُحفظ لقطة لتدفق "مراجعة العناصر المتأثرة" ضمن إعادة المعاينة.',
      fsHeads: "رؤوس القوائم المالية",
      searchPh: "ابحث بالكود / السطر / التصنيف",
      groupByPlacement: "التجميع حسب التصنيف",
      noLinesMatch: 'لا توجد سطور قوائم مالية مطابقة لـ "{q}"',
      selectedLine: "المُحدد: {codes}",
      selectedPlusPlacements: " + {placements}",
      glFile: "ملف الأستاذ العام",
      loadedRows: "تم تحميل {n} صفًا",
      clickToReplace: "(انقر للاستبدال)",
      parsingBg: "جاري تحليل الملف الكبير في الخلفية…",
      parsing: "جاري التحليل…",
      choose: "اختر ملفًا — .csv, .xlsx, .xls, .xlsm",
      columnMapping: "تخطيط الأعمدة",
      voucherCol: "عمود السند:",
      noVoucherMapped: "لم يتم ربط عمود السند — ستحصل الصفوف على عناصر نائبة V-####",
      notMapped: "— غير مربوط —",
      cancel: "إلغاء",
      uploading: "جاري التحميل…",
      uploadAppend: "تحميل (إلحاق)",
      uploadReplace: "تحميل (استبدال لكل رأس)",
      toastUnsupported: "ملف غير مدعوم — استخدم CSV أو Excel",
      toastFinalizeNoJob: "لم يُرجع إنهاء التحميل معرف مهمة",
      toastFileFirst: "قم بتحميل ملف أولاً",
      toastPickFsHead: "اختر رأسًا واحدًا على الأقل من القوائم المالية أو تصنيفًا",
      toastPreviewFailed: "فشلت المعاينة",
      toastFileParseFailed: "فشل تحليل الملف",
      toastCompleteAppend: "اكتمل تحميل الأستاذ حسب الرأس — تم إدراج {n}",
      toastCompleteReplace: "اكتمل تحميل الأستاذ حسب الرأس — تم إدراج {n} · استُبدل {r} من صفوف الأستاذ حسب الرأس السابقة للرؤوس المحددة (0 = أول تحميل لهذه الرؤوس؛ صفوف الأستاذ الرئيسي لا تُمس)",
      toastCompleteFailed: "فشل تحميل الأستاذ حسب الرأس",
      parsingFile: "جاري تحليل الملف…",
      uploadingChunks: "جاري تحميل {mb} ميغابايت في أجزاء…",
      fields: {
        voucherLabel: "السند / UIN",
        voucherHint: "العمود الذي يحمل رقم السند أو UIN — اتركه فارغًا للرجوع إلى عناصر نائبة V-####",
        entryDate: "تاريخ القيد",
        accountCode: "كود الحساب",
        accountName: "اسم الحساب",
        description: "الوصف",
        debit: "مدين",
        credit: "دائن",
        vendorCustomer: "المورّد / العميل",
      },
    },
    headTimeline: {
      title: "الجدول الزمني للبند",
      desc: "كل عملية رفع مسّت هذا البند، الأحدث أولاً. عمليات الاستبدال يمكن التراجع عنها (تُعيد صفوف اللقطة) إذا لم تحل محلها عملية استبدال أحدث على هذا البند.",
      loading: "جاري تحميل الجدول الزمني…",
      noUploads: "لا توجد عمليات رفع على مستوى البند لـ {code} بعد.",
      when: "متى",
      by: "بواسطة",
      mode: "الوضع",
      inserted: "إدراج",
      replaced: "استبدال",
      status: "الحالة",
      actions: "الإجراءات",
      undone: "تم التراجع",
      undoneBy: "تم التراجع بواسطة {name} — {at}",
      live: "نشط",
      diff: "مقارنة",
      undo: "تراجع",
      undoConfirm: "التراجع عن هذا الاستبدال؟ سيتم إعادة إدراج صفوف اللقطة على مستوى البند، وكل ما أضافته هذه العملية سيُحذف.",
      undoComplete: "اكتمل التراجع — تم حذف {deleted} · تمت استعادة {restored}",
      undoFailed: "فشل التراجع",
      diffFailed: "فشل تحميل المقارنة",
      diffTitle: "معاينة المقارنة — اللقطة مقابل الحالي",
      diffDesc: "العمود الأيمن: الصفوف المُلتقطة قبل تشغيل الاستبدال مباشرةً. العمود الأيسر: الصفوف الحالية في مجمع البند.",
      loadingDiff: "جاري تحميل المقارنة…",
      snapshotHdr: "اللقطة (قبل) · {n} صف",
      currentHdr: "الحالي (بعد) · {n} صف",
      voucher: "السند",
      acc: "الحساب",
      andMore: "…و{n} أخرى.",
    },
    glEntry: {
      loading: "جاري تحميل القيد…",
      notFound: "القيد غير موجود",
      back: "العودة إلى استيراد الأستاذ",
      title: "قيد الأستاذ",
      copy: "نسخ",
      copied: "تم النسخ",
      copyFailed: "فشل النسخ",
      labels: {
        entryId: "معرّف القيد",
        voucher: "رقم السند / UIN",
        entryDate: "تاريخ القيد",
        accountCode: "رمز الحساب",
        accountName: "اسم الحساب",
        debit: "مدين",
        credit: "دائن",
        net: "الصافي (مدين − دائن)",
        description: "الوصف",
        vendorCustomer: "المورد / العميل",
        categoryHint: "دلالة الفئة",
        postedBy: "المسجِّل",
        postedTime: "وقت التسجيل",
        period: "الفترة",
      },
    },
    subLedgerTab: {
      dsoNoOpeningAr: "غير متاح — رصيد الذمم المدينة الافتتاحي غير موجود في دفتر الأستاذ المساعد",   // Batch 25 · C6
      title: "محلل الأستاذ الفرعي — المبيعات / الذمم المدينة",
      uploadBtn: "رفع تفاصيل الأستاذ الفرعي",
      empty: "لا توجد تحليلات مخزّنة بعد — قم برفع الأستاذ الفرعي واضغط \"إعادة حساب\".",
      dsoLabel: "DSO (أيام تحصيل الذمم المدينة) — آخر 90 يوماً",
      cnLabel: "نسبة إشعارات الدائن — شهرياً",
      ptdLabel: "انحراف شروط السداد — شهرياً",
      ptdLabelFull: "معدل انحراف شروط السداد — شهرياً",
      woLabel: "معدل الشطب — شهرياً",
      cPeriodEnd: "نهاية الفترة",
      cArAvg: "الذمم المدينة (متوسط متتابع)",
      cRevenue90d: "الإيرادات (90 يوماً)",
      cDsoDays: "DSO (أيام)",
      cInvoices: "الفواتير",
      cCreditNotes: "إشعارات الدائن",
      cRatio: "النسبة",
      cEligible: "المؤهل",
      cDeviated: "منحرف",
      cWriteOffs: "الشطب",
      cRate: "المعدل",
      cPeriod: "الفترة",
      dcCustomer: "العميل",
      dcRefInvoice: "مرجع الفاتورة",
      dcAmount: "المبلغ",
      coverageLabel: "تغطية مرجع الفاتورة: {pct}",
      coverageOf: "({elig} مؤهل من أصل {total} فاتورة)",
      coverageBadge: "الحد: > {n} يوماً متأخر",
      coverageLow: "التغطية أقل من 20% — هذا المعدل غير تمثيلي حتى يتم توفير المزيد من ربط الفواتير.",
      drillNote: " ارتفاع الاتجاه + هذا التعمّق كافيان للاستفسار؛ القائمة الكاملة عمل تبويب العينات.",
      tRecomputeQueued: "تم إدراج إعادة حساب دورة الطلب إلى النقد في قائمة الانتظار على أسطول العمّال.",
      tRecomputed: "تمت إعادة حساب تحليلات دورة الطلب إلى النقد.",
    },
    tradePayableTab: {
      title: "محلل الأستاذ الفرعي — الذمم الدائنة",
      uploadBtn: "رفع تفاصيل الذمم الدائنة",
      empty: "لا توجد تحليلات مخزّنة بعد — قم برفع ملف الذمم الدائنة واضغط \"إعادة حساب\".",
      dpoLabel: "DPO (أيام سداد الذمم الدائنة) — آخر 90 يوماً",
      prLabel: "نسبة مردودات المشتريات — شهرياً",
      ppdLabel: "استخدام خصم السداد المبكر — شهرياً",
      cPeriodEnd: "نهاية الفترة",
      cApAvg: "الذمم الدائنة (متوسط متتابع)",
      cPurchases90d: "المشتريات (90 يوماً)",
      cDpoDays: "DPO (أيام)",
      cBills: "الفواتير",
      cDebitNotes: "إشعارات المدين",
      cRatio: "النسبة",
      cEligible: "المؤهل",
      cTaken: "المستخدم",
      cTakeupRate: "معدل الاستخدام",
      cPeriod: "الفترة",
      dcVendor: "المورد",
      dcRefBill: "مرجع الفاتورة",
      dcAmount: "المبلغ",
      coverageLabel: "تغطية مرجع الفاتورة + أيام الخصم: {pct}",
      coverageOf: "({elig} مؤهل من أصل {total} فاتورة)",
      coverageBadge: "فقط الفواتير التي لديها نافذة خصم ومدفوعات مرتبطة",
      coverageLow: "التغطية أقل من 20% — معدل الالتقاط هذا غير تمثيلي حتى يتم توفير المزيد من نوافذ الخصم + ربط المدفوعات.",
      tRecomputeQueued: "تم إدراج إعادة حساب الذمم الدائنة في قائمة الانتظار على أسطول العمّال.",
      tRecomputed: "تمت إعادة حساب تحليلات الذمم الدائنة.",
    },
  },
};

export default I18N_BASE_GL_HEADS;
